var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaredArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1997 11.0173L13.2297 9.04727L10.0197 5.83727C9.33969 5.16727 8.17969 5.64727 8.17969 6.60727V12.8373V18.4473C8.17969 19.4073 9.33969 19.8873 10.0197 19.2073L15.1997 14.0273C16.0297 13.2073 16.0297 11.8473 15.1997 11.0173Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaredArrow);
export default __webpack_public_path__ + "static/media/stared-arrow.0df3a7e4e49ccd2c0be6946590aa90a1.svg";
export { ForwardRef as ReactComponent };